import Landingpage from './Landingpage'

export default Landingpage
